import { Box, Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { StyledSkeleton } from '@omnea-app/fe-legacy/components/layout/skeleton/StyledSkeleton'
import { useFeatureFlags } from '@omnea-app/fe-org-settings/FeatureFlagsProvider'
import { useShowCardsOnDashboard } from '../../hooks/useShowCardsOnDashboard'
import { AuctionsWhatsNew } from './AuctionsWhatsNew'
import { NoActiveRfxs } from './NoActiveRfxs'
import { RfxDataGrid } from './RfxDataGrid'
import { RfxMobileCards } from './RfxMobileCards'
import { selectUpcomingSourcingEvents } from './selectUpcomingSourcingEvents'
import { useGetMyActiveAuctions } from './useGetMyActiveAuctions'
import { useGetMyActiveRfxs } from './useGetMyActiveRfxs'
import { SourcingEventRow } from './useRfxColumns'

export const RfxTable = () => {
  const { data: rfxData, isLoading: isRfxLoading } = useGetMyActiveRfxs()
  const { data: auctionData, isLoading: isAuctionLoading } = useGetMyActiveAuctions()
  const { t } = useTranslation('dashboard')
  const { AUCTIONS } = useFeatureFlags()
  const isLoading = isRfxLoading || isAuctionLoading

  const rows = selectUpcomingSourcingEvents([
    ...(rfxData ?? []).map((rfx): SourcingEventRow => ({ ...rfx, kind: 'RFX' })),
    ...(auctionData ?? []).map((auction): SourcingEventRow => ({
      ...auction,
      kind: 'AUCTION',
      status: null,
      deadlineType: 'BIDDING_CLOSES',
    })),
  ])
  const showCards = useShowCardsOnDashboard()

  return (
    <Stack gap={5} sx={{ width: '100%' }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        {isLoading ? (
          <Box sx={{ pb: 2 }}>
            <StyledSkeleton height={28} width={231} />
          </Box>
        ) : (
          <Typography variant="display-h3">{t('rfx-section.title')}</Typography>
        )}
        {AUCTIONS && !isLoading && <AuctionsWhatsNew />}
      </Stack>
      <Stack width="100%" sx={{ flex: 1 }}>
        {!isLoading && rows.length > 0 && (showCards ? <RfxMobileCards rows={rows} /> : <RfxDataGrid rows={rows} />)}
        {rows.length === 0 && !isLoading && <NoActiveRfxs />}
      </Stack>
    </Stack>
  )
}
